import { FC } from 'react';

import { DDPStatus } from '../../types/ddpTypes';

import styles from './Notitie.module.css';

const notitieStatusLabel = {
  NOTITIE_ORDER: 'Order',
  NOTITIE_ONDERHOUDSBOEK: 'Ohb',
  NOTITIE_OP_SB_OB: 'OB',
};

type NotitieStatusLabelKey = keyof typeof notitieStatusLabel;

type NotitieStatusProps = {
  status: NotitieStatusLabelKey extends DDPStatus ? NotitieStatusLabelKey : never;
};
const NotitieStatus: FC<NotitieStatusProps> = ({ status }) => {
  return <div className={styles[`notitieStatusStyle-${status}`]}>{notitieStatusLabel[status]}</div>;
};
export default NotitieStatus;
